export const GET_BOARD_COMPONENT_FAILURE = "GET_BOARD_COMPONENT_FAILURE";
export const GET_BOARD_COMPONENT_REQUEST = "GET_BOARD_COMPONENT_REQUEST";
export const GET_BOARD_COMPONENT_SUCCESS = "GET_BOARD_COMPONENT_SUCCESS";

export const GET_BOARD_COMPONENTS_FAILURE = "GET_BOARD_COMPONENTS_FAILURE";
export const GET_BOARD_COMPONENTS_REQUEST = "GET_BOARD_COMPONENTS_REQUEST";
export const GET_BOARD_COMPONENTS_SUCCESS = "GET_BOARD_COMPONENTS_SUCCESS";

export const GET_BOARD_COMPONENT_TYPES_FAILURE = "GET_BOARD_COMPONENT_TYPES_FAILURE";
export const GET_BOARD_COMPONENT_TYPES_REQUEST = "GET_BOARD_COMPONENT_TYPES_REQUEST";
export const GET_BOARD_COMPONENT_TYPES_SUCCESS = "GET_BOARD_COMPONENT_TYPES_SUCCESS";

export const ADD_BOARD_COMPONENT_FAILURE = "ADD_BOARD_COMPONENT_FAILURE";
export const ADD_BOARD_COMPONENT_REQUEST = "ADD_BOARD_COMPONENT_REQUEST";
export const ADD_BOARD_COMPONENT_SUCCESS = "ADD_BOARD_COMPONENT_SUCCESS";

export const UPDATE_BOARD_COMPONENT_FAILURE = "UPDATE_BOARD_COMPONENT_FAILURE";
export const UPDATE_BOARD_COMPONENT_REQUEST = "UPDATE_BOARD_COMPONENT_REQUEST";
export const UPDATE_BOARD_COMPONENT_SUCCESS = "UPDATE_BOARD_COMPONENT_SUCCESS";
